var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"circularloader"}},[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }